import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormState } from '@shared';
import { Store } from '@ngrx/store';
import * as fromUser from '@account-users/user/state';
import { UserState } from '@account-users/user/state/users/users.reducer';
import { Observable } from 'rxjs';
import {
  BulkEditAccountUserPermissions,
  DownloadPermissionRemoveCSV,
} from '@account-users/user/state/users/users.actions';
import { IBulkEdit } from '@account-users/account/models/LicensePermissionList';

@Component({
  selector: 'app-confirm-bulk-edit-modal',
  templateUrl: './confirm-bulk-edit-modal.component.html',
  styleUrls: ['./confirm-bulk-edit-modal.component.scss'],
})
export class ConfirmBulkEditModalComponent {
  FormState = FormState;
  bulkEditUsers$: Observable<IBulkEdit[]> = this.store.select(
    fromUser.getBulkEdit,
  );
  selectedUsersCount$: Observable<number> = this.store.select(
    fromUser.getSelectedUsersCount,
  );
  bulkEditSuccess$: Observable<IBulkEdit[]> = this.store.select(
    fromUser.getBulkEditSuccess,
  );
  bulkEditFailed$: Observable<IBulkEdit[]> = this.store.select(
    fromUser.getBulkEditFailed,
  );
  isLoading$: Observable<boolean> = this.store.select(
    fromUser.getAccountUserBulkPermissionLoading,
  );
  formState$ = this.store.select(fromUser.getBulkEditFormState);

  constructor(
    public activeModal: NgbActiveModal,
    private store: Store<UserState>,
  ) {}

  confirm() {
    this.store.dispatch(new BulkEditAccountUserPermissions());
  }

  export() {
    this.store.dispatch(new DownloadPermissionRemoveCSV());
  }
}
